import { EntUnitMeasurement } from "./unitMeasurement";

export class EntTypeAnimal {
  id: number = 0; 
  nameRu: string = "";
  nameKy: string = "";
  editedTime: string = "";
  createdTime: string = "";
  unitMeasurementId: number | null = 0
  unitMeasurement: EntUnitMeasurement | null = null
}
